import { render, staticRenderFns } from "./form-formulary.vue?vue&type=template&id=67bb8eb4"
import script from "./form-formulary.vue?vue&type=script&lang=js"
export * from "./form-formulary.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports